import { render, staticRenderFns } from "./salesOrderDetail.vue?vue&type=template&id=5d238382&scoped=true&"
import script from "./salesOrderDetail.vue?vue&type=script&lang=js&"
export * from "./salesOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderDetail.vue?vue&type=style&index=0&id=5d238382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d238382",
  null
  
)

export default component.exports